import styled from "styled-components";

export const Box = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .interDisplay {
    font-family: InterDisplay;
  }

  .defaultText {
    font-family: Arial, sans-serif;
  }


  .container_sero {
    max-width: 1200px;
    margin: 0 auto;
  }


  .container_sero .grid {
    display: grid;
    grid-template-columns: 40% 60%;
    gap: 1.2rem;
    width: 100%;
    align-items: stretch;
  }

  @media (max-width: 1100px) {
    .container_sero .grid {
      grid-template-columns: 1fr;
    }

    .serp-preview1 {
      margin-top: 1rem;
    }
  }


  .container_sero .card {
    background: #fff;
    padding: 1.6rem;
    border-radius: 14px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    width: 100%;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .form-group label {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 6px;
    display: block;
  }

  input,
  textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    background: #fff;
  }

  input:focus,
  textarea:focus {
    outline: none;
    border-color: #8cc540;
  }


  .button-group {
    display: flex;
    gap: 0.6rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
  }

  .button {
    padding: 0.55rem 1.2rem;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }

  .button-primary {
    background: #8cc540;
    color: #fff;
  }


  .pixel-bar-wrapper {
    width: 100%;
    height: 4px;
    background: #e5e7eb;
    border-radius: 10px;
    margin-bottom: 6px;
    overflow: hidden;
  }

  .pixel-bar {
    height: 100%;
    border-radius: 10px;
    transition: width 0.25s ease;
  }

  .warning-box {
    background: #ffecec;
    color: #a94442;
    padding: 10px;
    border-left: 4px solid #d9534f;
    border-radius: 6px;
    font-size: 13px;
    margin-top: 6px;
  }


  .serp-preview1 {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .serp-preview1::before {
    content: "";
    display: block;
    height: 18px;
    background: #d5d6e0;
  }

  .search-header {
    padding: 18px 20px 10px;
    border-bottom: 1px solid #ebebeb;
  }

  .search-logo img {
    width: 92px;
    margin-bottom: 10px;
  }

  .formgoogle {
    position: relative;
    width: 100%;
  }

.search-input-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

.mg-label {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  background: #ffbe02;
  color: #fff;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 1;
  z-index: 2;
  pointer-events: none;
}

  .search-input {
  width: 100%;
  height: 42px;
  border-radius: 24px;
  border: 1px solid #dfe1e5;
  padding-left: 72px;
  padding-right: 16px;
  font-size: 15px;
  box-sizing: border-box;
}

  .search-menu {
    display: flex;
    gap: 14px;
    padding: 8px 20px 0;
    font-size: 13px;
    color: #5f6368;
  }

  .search-cat {
    padding-bottom: 10px;
    cursor: default;
  }

  .search-cat.is-active {
    color: #1a73e8;
    font-weight: 600;
    border-bottom: 3px solid #1a73e8;
  }


  .search-count {
    padding: 10px 20px;
    font-size: 13px;
    color: #70757a;
  }

  .serp-url {
    padding: 0 20px;
    font-size: 14px;
    color: #006621;
    margin-bottom: 4px;
    word-break: break-word;
  }

  .serp-title {
    padding: 0 20px;
    font-size: 18px;
    color: #1a0dab;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  .serp-title:hover {
    text-decoration: underline;
  }

  .serp-description {
    padding: 6px 20px 14px;
    font-size: 14px;
    color: #545454;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .serp-description strong {
    font-weight: bold;
  }


  .serp-result {
    padding: 0 20px 14px;
  }

  .snippet-url,
  .snippet-title,
  .snippet-descr {
    display: block;
    border-radius: 4px;
    opacity: 0.3;
    margin-bottom: 8px;
  }

  .snippet-url {
    width: 30%;
    height: 14px;
    background: #5f6368;
  }

  .snippet-title {
    width: 60%;
    height: 16px;
    background: #1a0dab;
  }

  .snippet-descr {
    width: 90%;
    height: 38px;
    background: #4d5156;
  }


  @media (max-width: 768px) {
    .search-header {
      padding: 14px;
    }

    .search-menu {
      padding-left: 14px;
      flex-wrap: wrap;
    }
  }
`;
